export const documents = {
  noDocuments1: 'Sie haben derzeit noch keine Unterlagen hinterlegt',
  noDocuments2: 'Wenn Sie Unterlagen hochladen, werden diese hier dargestellt',
  noDocuments3: 'Alle hochgeladenen Unterlagen auf einen Blick!',
  noDocuments4:
    'Unterlagen, die Sie in Ihrem Projekt hochgeladen haben, sind auch hier ersichtlich',
  noDocuments5: 'Unterlagen kategorisierbar',
  uploadDocument: 'Unterlage hochladen',
  uploadErrorToastText: 'Ihre Unterlage konnte nicht hochgeladen werden.',
  name: 'Dateiname',
  category: 'Kategorie',
  buyAndSell: 'Kauf/Verkauf',
  taxes: 'Steuern',
  insurance: 'Versicherung',
  finance: 'Finanzen',
  renovation: 'Renovation',
  other: 'Sonstiges',
  deleteModalButtonText: 'Löschen',
  deleteModalTitle: 'Sind Sie sicher, dass Sie Ihre Unterlage löschen möchten?',
  all: 'Alle',
}
